//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    {
        name: "Home",
        path: "",
        meta: { name: "Home", type: "Home Page" },
        component: () => import("@/views/main/index.vue"),
    },
    {
        name: "Search",
        path: "/search",
        meta: { routeParent: "Home", name: "SearchResult", type: "Search" },
        component: () => import("@/views/search/main/index.vue"),
    },
    {
        name: "SearchGene",
        path: "/search/gene",
        meta: { routeParent: "Search", name: "Gene", type: "Search" },
        component: () => import("@/views/search/list/view/Gene.vue"),
    },
    {
        name: "SearchModel",
        path: "/search/model",
        meta: { routeParent: "Search", name: "Model", type: "Search" },
        component: () => import("@/views/search/list/view/Model.vue"),
    },
    {
        name: "SearchDisease",
        path: "/search/disease",
        meta: { routeParent: "Search", name: "Disease", type: "Search" },
        component: () => import("@/views/search/list/view/Disease.vue"),
    },
    {
        name: "SearchMutation",
        path: "/search/mutation",
        meta: { routeParent: "Search", name: "Variant", type: "Search" },
        component: () => import("@/views/search/list/view/Mutation.vue"),
    },
    {
        name: "Gene",
        path: "/gene/:id",
        meta: { type: "Gene" },
        component: () => import("@/views/details/gene/index.vue"),
    },
    {
        name: "Model",
        path: "/model/:id",
        meta: { type: "Model" },
        component: () => import("@/views/details/model/index.vue"),
    },
    {
        name: "Disease",
        path: "/disease/:id",
        meta: { type: "Disease" },
        component: () => import("@/views/details/disease/index.vue"),
    },
    {
        name: "Transition",
        path: "/transition",
        component: () => import("@/views/public/functions/Transition.vue"),
    },
    {
        name: "ContactUs",
        path: "/contact-us",
        meta: { type: "Contact Us" },
        component: () => import("@/views/contact-us/index.vue"),
    },
    {
        name: "About",
        path: "/about",
        component: () => import("@/views/public/exhibits/about/index.vue"),
    },
    {
        name: "Privacy",
        path: "/privacy",
        component: () => import("@/views/public/exhibits/privacy/index.vue"),
    },
    {
        name: "Chatagent",
        path: "/chatagent",
        meta: { type: "AI-Agent" },
        component: () => import("@/views/chatagent/index.vue"),
    },
    {
        name: "Tool",
        path: "/tool",
        meta: { type: "Tools" },
        component: () => import("@/views/tool/views/main/index.vue"),
    },
    {
        path: "/tool/abbreviation-converter",
        name: "AbbreviationConverter",
        component: () => import("@/views/tool/views/abbreviation-converter/index.vue"),
    },
    {
        path: "/tool/genetic-comparison",
        name: "GeneticComparison",
        meta: { mode: "gene" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/diseases-comparison",
        name: "DiseasesComparison",
        meta: { mode: "disease" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/model-comparison",
        name: "ModelComparison",
        meta: { mode: "model" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/rna-splicer",
        name: "RnaSplicer",
        meta: { type: "RNA Splicer" },
        component: () => import("@/views/tool/views/rna-splicer/main/index.vue"),
    },
    {
        path: "/tool/rna-splicer/:id",
        name: "RnaSplicerResult",
        meta: { type: "RNA Splicer" },
        component: () => import("@/views/tool/views/rna-splicer/result/index.vue"),
    },
    {
        path: "/tool/pathogenicity",
        name: "Pathogenicity",
        meta: { type: "Pathogenicity Predictor" },
        component: () => import("@/views/tool/views/pathogenicity/main/index.vue"),
    },
    {
        path: "/tool/pathogenicity/:id",
        name: "PathogenicityResult",
        meta: { type: "Pathogenicity Predictor" },
        component: () => import("@/views/tool/views/pathogenicity/result/index.vue"),
    },
    {
        path: "/tool/mouse-pheno-predict",
        name: "MousePhenoPredict",
        component: () => import("@/views/tool/views/mouse-pheno-predict/index.vue"),
    },
    {
        path: "/tool/mouse-pheno-predict/:id",
        name: "MousePhenoPredictResult",
        component: () => import("@/views/tool/views/mouse-pheno-predict/childrens/result/index.vue"),
    },
    {
        path: "/tool/variant",
        name: "BioVariant",
        meta: { type: "Variant" },
        component: () => import("@/views/tool/views/variant/main/index.vue"),
    },
    {
        path: "/tool/variant/:id",
        name: "BioVariantResult",
        meta: { type: "Variant" },
        component: () => import("@/views/tool/views/variant/result/index.vue"),
    },
    {
        name: "ASO",
        path: "/tool/aso",
        component: () => import("@/views/tool/views/aso-tool/views/main/index.vue"),
    },
    {
        path: "/tool/aso/result",
        name: "ASOResult",
        component: () => import("@/views/tool/views/aso-tool/views/result/index.vue"),
    },
    {
        path: "/tool/aso/manual",
        name: "ASOManual",
        component: () => import("@/views/tool/views/aso-tool/views/manual/index.vue"),
    },
    {
        path: "/tool/sequence-alignment",
        name: "SequenceAlignment",
        component: () => import("@/views/tool/views/sequence-alignment/main/index.vue"),
    },
    {
        path: "/tool/sequence-alignment/result",
        name: "SequenceAlignmentResult",
        component: () => import("@/views/tool/views/sequence-alignment/result/index.vue"),
    },
    {
        path: "/tool/sequence",
        name: "BioSequence",
        component: () => import("@/views/tool/views/sequence/main/index.vue"),
    },
    {
        path: "/tool/sequence/:id",
        name: "BioSequenceResult",
        component: () => import("@/views/tool/views/sequence/result/index.vue"),
    },
    {
        path: "/tool/MTH",
        name: "MTH",
        component: () => import("@/views/tool/views/MTH/main/index.vue"),
    },
    {
        path: "/tool/MTH/:id",
        name: "MTHResult",
        component: () => import("@/views/tool/views/MTH/result/index.vue"),
    },
    {
        path: "/tool/signal-path",
        name: "SignalPath",
        component: () => import("@/views/tool/views/signal-path/index.vue"),
    },
    {
        path: "/tool/signal-path/result",
        name: "SignalPathResult",
        component: () => import("@/views/tool/views/signal-path/result/index.vue"),
    },
    {
        path: "/tool/signal-path/detail",
        name: "SignalPathDetail",
        component: () => import("@/views/tool/views/signal-path/detail/index.vue"),
    },
    {
        path: "/tool/DBSNP",
        name: "DBSNP",
        component: () => import("@/views/tool/views/dbsnp/index.vue"),
    },
    {
        path: "/tool/DBSNP/result",
        name: "DBSNPResult",
        component: () => import("@/views/tool/views/dbsnp/childrens/result/index.vue"),
    },
    {
        path: "/tool/cbl",
        name: "CBL",
        component: () => import("@/views/tool/views/cbl/index.vue"),
    },
    {
        path: "/tool/dg-prediction",
        name: "DGPrediction",
        component: () => import("@/views/tool/views/dg/index.vue"),
    },
    {
        path: "/tool/blat",
        name: "BLAT",
        component: () => import("@/views/tool/views/blat/main/index.vue"),
    },
    {
        path: "/tool/blat/:id",
        name: "BLATResult",
        component: () => import("@/views/tool/views/blat/result/index.vue"),
    },
    {
        path: "/tool/transform-id",
        name: "TransformID",
        component: () => import("@/views/tool/views/transform-id/index.vue"),
    },
    {
        path: "/timely-upadated",
        name: "TimelyUpadated",
        component: () => import("@/views/timely-upadated/index.vue"),
    },
    {
        path: "/data-visualization",
        name: "DataVisualization",
        component: () => import("@/views/data-visualization/index.vue"),
    },
    {
        path: "/data-simplication",
        name: "DataSimplication",
        component: () => import("@/views/data-simplication/index.vue"),
    },
    {
        path: "/all-in-one",
        name: "AllInOne",
        component: () => import("@/views/all-in-one/index.vue"),
    },
    {
        path: "/workflow/workflow1",
        name: "Workflow",
        component: () => import("@/views/workflow/workflow1/index.vue"),
    },
    {
        path: "/workflow/variantseek",
        name: "Variantseek",
        component: () => import("@/views/workflow/variantseek/index.vue"),
    },
    {
        path: "/tool/sequence-processor",
        name: "SequenceProcessor",
        component: () => import("@/views/tool/views/sequence-processor/main/index.vue"),
    },
    {
        path: "/tool/sequence-processor/:id",
        name: "SequenceProcessorResult",
        component: () => import("@/views/tool/views/sequence-processor/result/index.vue"),
    },
] as RouteRecordRaw[];
